import React from 'react';
import PropTypes from 'prop-types';

import TitleBar from 'components/title_bar';
import classNames from 'classnames';

export default function Header({ modelName, templateName, saving, onCancel, onSave }) {
  return (
    <TitleBar subtitle={templateName} title={`Edit ${modelName}`}>
      <div className={classNames('btn btn-save mr-2', { 'disabled': saving })} onClick={onSave}>
        Save
      </div>
      <div className={classNames('btn btn-cancel', { 'disabled': saving })} onClick={onCancel}>Cancel</div>
    </TitleBar>
  );
}

Header.propTypes = {
  modelName: PropTypes.string.isRequired,
  saving: PropTypes.bool,
  templateName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
